import React from 'react';

export const Datadog = React.lazy((): Promise<typeof import('@/features/Datadog')> => import('@/features/Datadog'));
export const ChargingHub = React.lazy(
  (): Promise<typeof import('@/features/Charging/ChargingHub')> => import('@/features/Charging/ChargingHub'),
);
export const ChargingDetail = React.lazy(
  (): Promise<typeof import('@/features/Charging/ChargingDetail')> => import('@/features/Charging/ChargingDetail'),
);
export const Header = React.lazy(
  (): Promise<typeof import('@/features/Navigation/Header')> => import('@/features/Navigation/Header'),
);
export const Layout = React.lazy(
  (): Promise<typeof import('@/common/components/Layout')> => import('@/common/components/Layout'),
);
export const PageNotFound = React.lazy(
  (): Promise<typeof import('@/common/components/PageNotFound')> => import('@/common/components/PageNotFound'),
);
export const RouteError = React.lazy(
  (): Promise<typeof import('@/common/components/RouteError')> => import('@/common/components/RouteError'),
);
export const SolutionHomeOverview = React.lazy(
  (): Promise<typeof import('@/features/Solution/SolutionHomeOverview')> =>
    import('@/features/Solution/SolutionHomeOverview'),
);
export const ImportedDataChassisData = React.lazy(
  (): Promise<typeof import('@/features/ImportedData/ChassisData')> => import('@/features/ImportedData/ChassisData'),
);
export const ImportedDataCurrentFleet = React.lazy(
  (): Promise<typeof import('@/features/ImportedData/CurrentFleet')> => import('@/features/ImportedData/CurrentFleet'),
);
export const SolutionManager = React.lazy(
  (): Promise<typeof import('@/features/Solution/SolutionManager')> => import('@/features/Solution/SolutionManager'),
);
export const ReleaseNotes = React.lazy(
  (): Promise<typeof import('@/features/Solution/ReleaseNotes')> => import('@/features/Solution/ReleaseNotes'),
);
export const BevHub = React.lazy(
  (): Promise<typeof import('@/features/Bev/BevHub')> => import('@/features/Bev/BevHub'),
);
export const BevDetail = React.lazy(
  (): Promise<typeof import('@/features/Bev/BevDetail')> => import('@/features/Bev/BevDetail'),
);
export const ImportCandidates = React.lazy(
  (): Promise<typeof import('@/features/ImportCandidates')> => import('@/features/ImportCandidates'),
);
